// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root {
  font-family: "IBM Plex Sans", sans-serif;
}
body {
  margin: 0;
  font-family: "IBM Plex Sans", sans-serif;
  font-weight: 300;
}

h2 {
  font-weight: 500;
}

.heading {
  background: linear-gradient(to left, #44aa99 0%, #332288 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  font-weight: 500;
}

.hide {
  display: none;
}

a {
  color: #28477f;
}

.noDataTableHeader thead {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;AAC1C;AACA;EACE,SAAS;EACT,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8DAA8D;EAC9D,6BAA6B;EAC7B,oCAAoC;;EAEpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".root {\n  font-family: \"IBM Plex Sans\", sans-serif;\n}\nbody {\n  margin: 0;\n  font-family: \"IBM Plex Sans\", sans-serif;\n  font-weight: 300;\n}\n\nh2 {\n  font-weight: 500;\n}\n\n.heading {\n  background: linear-gradient(to left, #44aa99 0%, #332288 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n\n  font-weight: 500;\n}\n\n.hide {\n  display: none;\n}\n\na {\n  color: #28477f;\n}\n\n.noDataTableHeader thead {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
